import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IHistoryActionButton } from '../../../interfaces/history.interface';

@Component({
  selector: 'gen-history-actions',
  templateUrl: './history-actions.component.html',
  styleUrls: ['./history-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryActionsComponent implements OnInit {

  @Input() actions: IHistoryActionButton[] = [];
  constructor() { }

  ngOnInit() {
  }

}
